import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Jennifer M.",
      location: "Tucson, AZ",
      rating: 5,
      text: "Outstanding service! They removed three large stumps from my backyard in just a few hours. The crew was professional, on time, and left my yard cleaner than they found it. Highly recommend!",
    },
    {
      name: "Robert K.",
      location: "Oro Valley, AZ",
      rating: 5,
      text: "Best stump grinding service in Tucson! After a monsoon took down our old mesquite tree, they came out the same day and ground the stump down completely. Fair pricing and great communication.",
    },
    {
      name: "Maria S.",
      location: "Sahuarita, AZ",
      rating: 5,
      text: "I had 5 stumps from old citrus trees that needed to go before landscaping. They gave me an honest quote and completed the work in one morning. My yard finally looks amazing!",
    },
    {
      name: "David H.",
      location: "Catalina, AZ",
      rating: 5,
      text: "Professional and efficient. They navigated tight access to my backyard with no problem and ground down a massive palo verde stump. The mulch they left behind is perfect for my garden beds.",
    },
    {
      name: "Susan T.",
      location: "SaddleBrooke, AZ",
      rating: 5,
      text: "Excellent experience from start to finish. Quick quote, reasonable price, and the work was done in half the time I expected. They even ground some surface roots that were damaging my walkway.",
    },
    {
      name: "Michael R.",
      location: "Oracle, AZ",
      rating: 5,
      text: "Living in a rural area, I wasn't sure anyone would come out to Oracle, but they did! Removed two large oak stumps without any issues. Very impressed with their equipment and expertise.",
    },
  ];

  return (
    <section id="testimonials" className="py-16 lg:py-24 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <div className="accent-line mx-auto mb-4" />
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] uppercase mb-4">
            What Our Customers Say
          </h2>
          <p className="font-body text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what homeowners across Tucson and surrounding areas have to say about our stump grinding services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#F5F5F0] border-2 border-[#E5E5E0] p-6 relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#FF4D00] mb-4" strokeWidth={1.5} />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-[#FF4D00] text-[#FF4D00]"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="font-body text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t-2 border-[#E5E5E0] pt-4">
                <div className="font-heading font-bold text-[#1A1A1A] uppercase">
                  {testimonial.name}
                </div>
                <div className="font-body text-sm text-gray-500">
                  {testimonial.location}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Review CTA */}
        <div className="mt-12 text-center">
          <p className="font-body text-gray-600 mb-4">
            Join hundreds of satisfied Tucson homeowners
          </p>
          <a
            href="#quote"
            className="inline-block btn-primary px-8 py-4 rounded-none"
            data-testid="testimonials-cta"
          >
            Get Your Free Quote Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
